import { useGainsightIdentifyUser } from './useGainsightIdentifyUser';
import { useGainsightClickTracker } from './useGainsightClickTracker';

export const GainsightAnalytics = () => {
  useGainsightIdentifyUser();
  useGainsightClickTracker();
  return null;
};
